import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ISupporterSendPasswordResetEmailClient,
} from 'interfaceAdapter/gatewaySchemas/ISupporterSendPasswordResetEmailClient';

const PATH = `${API_LOCATION_URL}/supporter/user/send_password_reset_email`;

export class SupporterSendPasswordResetEmailClient implements ISupporterSendPasswordResetEmailClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { email } = input;
        const method = 'POST';
        const headers = {
            'Content-Type': 'application/json',
        };
        const body = JSON.stringify({ email });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
